/* eslint-disable react/react-in-jsx-scope */
import { Checkbox } from "@mui/material"

export const parseFinalPublicationsTable = ({
  data,
  filteredIds,
  isAllChecked,
  onOpenDetails,
  onOpenTags,
  onAllSelected,
  onRowSelect,
  rowsSelected,
}) => {
  const columns = [
    // # (seleção + ação de detalhes)
    {
      field: "actions",
      headerName: "#",
      sortable: false,
      disableColumnMenu: true,
      width: 120,
      renderHeader: () => {
        return filteredIds.length ? (
          <Checkbox
            checked={isAllChecked}
            sx={{ "&.Mui-checked": { color: "#677de8" } }}
            onClick={({ target }) => onAllSelected(target.checked)}
          />
        ) : null
      },
      renderCell: params => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Checkbox
            checked={rowsSelected.some(
              item => params.row.Id === item.id && !!item.isSend
            )}
            sx={{ "&.Mui-checked": { color: "#677de8" } }}
            onClick={({ target }) => {
              onRowSelect(params.row.Id, !target.checked)
            }}
          />
          <button
            className="btn btn-sm btn-soft-primary"
            onClick={() => {
              const processId =
                params.row?.Processo?.Id ||
                params.row?.Id_Processo ||
                params.row?.Id
              if (processId) {
                window.open(`/qualificacao-detail/${processId}`, "_blank")
              }
            }}
            title="Analisar"
          >
            Analisar
          </button>
        </div>
      ),
    },
    // É Lead? (mapeia isLead)
    {
      field: "IsLead",
      headerName: "É Lead?",
      flex: 1,
      renderCell: params => {
        const raw =
          params.row?.IsLead !== undefined && params.row?.IsLead !== null
            ? params.row?.IsLead
            : params.row?.Processo?.IsLead
        if (raw === true) return <div>sim</div>
        if (raw === false || raw === null) return <div>não</div>
        return <div>-</div>
      },
    },
    // Data do Alerta (DataCadastro)
    {
      field: "DataCadastro",
      headerName: "Data do Alerta",
      flex: 1,
      renderCell: params => {
        const dateStr = params.row?.DataCadastro || params.row?.DataPublicacao
        return (
          <div>
            {dateStr ? new Date(dateStr).toLocaleDateString("pt-BR") : "N/A"}
          </div>
        )
      },
    },
    // Processo (tenta vários campos conhecidos, senão N/A)
    {
      field: "NumeroCNJ",
      headerName: "Processo",
      flex: 1,
      renderCell: params => {
        const value = (
          params.row?.NumeroCNJ || params.row?.Processo?.NumeroCNJ || "N/A"
        )
          .toString()
          .trim() || "N/A"
        return <div>{value}</div>
      },
    },
    // Status (status)
    {
      field: "Status",
      headerName: "Status",
      flex: 1,
      renderCell: params => (
        <div>
          {params.row?.Status ??
            params.row?.status ??
            params.row?.Processo?.Status ??
            "-"}
        </div>
      ),
    },
  ]

  const rows = data ? data.map(item => ({ ...item, id: item.Id })) : []

  return { columns, rows }
}
